import React from 'react';
import { FormattedMessage } from 'react-intl';

const Error = ({ errorCode }) => {
  const messages = [
    'invalid_input',
    'not_opened',
    'not_related',
    'pos_not_found',
    'pos_not_set',
    'series_not_set',
    'transaction_not_balanced',
    'transaction_line_inconsistency',
    'payments_inconsistency'
  ];
  let messageId = messages.indexOf(errorCode.toLowerCase()) > -1 ? 'error.' + errorCode.toLowerCase() : 'error.default';

  return <FormattedMessage id={messageId}/>;
};

export default Error;
